import { service } from "@ember/service";
import type Patient from "parog-web/models/patient";
import { Ability } from "ember-can";
import type SemeiaSessionService from "parog-web/services/session";

export default class FormAbility extends Ability {
  @service declare session: SemeiaSessionService;

  /** This optional parameter is passed when checking abilities */
  context?: { patient: Patient } = undefined;
  declare model: string;

  get canArchive(): boolean {
    return (
      !this.session.patient &&
      this.canEdit &&
      [
        "abdominal-area/edition-form",
        "bio-exam-results/edition-form",
        "capillarity-blood-glucose/edition-form",
        "constant-monitoring/edition-form",
        "consultation/edition-form",
        "consultation/report-form",
        "feeling-evas/form",
        "measurements/weight-edition-form",
        "online-consultation/report-edition-form",
        "oxygene-saturation/edition-form",
        "prescription/bio-exam-edition-form",
        "prescription/medication-edition-form",
        "prescription/medical-imaging-edition-form",
        "prescription/paramedical-care-edition-form",
        "respiratory-rate/edition-form",
        "scale-surveys/fast-edition-form",
        "scale-surveys/qids-edition-form",
        "scale-surveys/ymrs-edition-form",
        "task/edition-form",
        "temperature/edition-form",
        "thymic-episode/edition-form",
        "vems-demm/edition-form",
        "stools-number/edition-form",
        "tls-prescription-edition-form"
      ].includes(this.model)
    );
  }

  // If no patient has been passed to the context, we can edit the form
  // If the patient is disenrolled, we cannot edit the form
  get canEdit(): boolean {
    const patient = this.context?.patient;
    if (!patient) return true;

    return !patient.isDisenrolled;
  }
}
